import React from "react";

const PaymentSummary = ({ earnings }) => {

    const paid = earnings.filter(
        e => e.paymentStatus === "Paid"
    ).length;

    const pending = earnings.filter(
        e => e.paymentStatus === "Pending"
    ).length;

    const failed = earnings.filter(
        e => e.paymentStatus === "Failed"
    ).length;

    return (

        <div className="payment-summary">

            <h3>Payment Summary</h3>

            <p>Paid : {paid}</p>

            <p>Pending : {pending}</p>

            <p>Failed : {failed}</p>

        </div>

    );

};

export default PaymentSummary;